var isCursorTop = function (monitor, hoverBoundingRect) {
    var hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
    var clientOffset = monitor.getClientOffset();
    var hoverClientY = clientOffset.y - hoverBoundingRect.top;
    return Math.floor(hoverClientY) < Math.floor(hoverMiddleY);
};

export { isCursorTop };
